import { Injectable } from '@angular/core';
import { CONSTANTS } from '@pk/powerkioskutils';
import moment from 'moment-timezone';
import { environment } from 'src/environments/environment';
import userflow from 'userflow.js';
import { SecurityService } from '../security/security.service';
import { oct1LicenseUpdate } from './userflow-rules/oct-1-license-update';

@Injectable({
	providedIn: 'root',
})
export class UserflowService {
	// this doesn't include the saas roles since Saas is already excluded overall
	private excludedRoles = [
		CONSTANTS.userRoles.supplierResidential.roleId,
		CONSTANTS.userRoles.supplierCommercial.roleId,
		CONSTANTS.userRoles.customer.roleId,
		CONSTANTS.userRoles.lead.roleId,
		CONSTANTS.userRoles.underwriter.roleId,
	];

	constructor(private securityService: SecurityService) {
		if (environment.userflowId) {
			userflow.init(environment.userflowId);
		}
	}

	get loggedInUser() {
		return this.securityService.authFields?.loggedInUser;
	}

	get isImpersonating() {
		return this.securityService.isImpersonating;
	}

	public async init(): Promise<void> {
		try {
			this.destroy(); // make sure it's destroyed before identifying a user so that only one session is active at a time
			if (environment.userflowId) {
				if (this.loggedInUser && !this.loggedInUser.isSaas && !this.excludedRoles.includes(this.loggedInUser.roleId)) {
					await userflow.identify(
						this.loggedInUser.userId,
						{
							name: this.loggedInUser.fullName,
							email: this.loggedInUser.email,
							signed_up_at: moment(this.loggedInUser.addDate).format('YYYY-MM-DDTHH:mm:ssZ'),
							role: this.loggedInUser.role.name,
							is_employee: this.loggedInUser.agent ? this.loggedInUser.agent.isEmployee : false,
							is_oct1_license_update: oct1LicenseUpdate.includes(this.loggedInUser.agentId),
						},
						{
							signature: this.loggedInUser.userflowSignature,
						},
					);
					// Need to upgrade to Adoption Studio Plan for below
					// await userflow.group(
					// 	this.loggedInUser.agentId ?? CONSTANTS.agents.powerkiosk,
					// 	{
					// 		name: this.loggedInUser.agent?.name ?? 'Power Kiosk',
					// 		signed_up_at: this.loggedInUser.agent
					// 			? moment(this.loggedInUser.agent?.addDate).format('YYYY-MM-DDTHH:mm:ssZ')
					// 			: '2020-01-01T00:00:00Z',
					// 	},
					// 	{
					// 		signature: this.loggedInUser.userflowSignature,
					// 	},
					// );
				} else {
					this.destroy();
				}
			}
		} catch (e) {
			console.error(e);
		}
	}

	public destroy(): void {
		if (environment.userflowId) {
			userflow.reset();
		}
	}
}
